module.exports = __webpack_public_path__ + "static/media/passwordLock.aa06ffb8.svg";